import dayjs from "dayjs";

export function getWeekNumber(date) {
  const startOfYear = dayjs(date).startOf("year");
  const daysPassed = dayjs(date).diff(startOfYear, "day");
  const startOfWeekOffset = startOfYear.day();
  const weekNumber = Math.ceil((daysPassed + startOfWeekOffset) / 7);

  return isNaN(weekNumber) ? "" : weekNumber.toString();
}